import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/User.svg?component
var User_exports = /* @__PURE__ */ __exportAll({
	default: () => User_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	"stroke-linecap": "round",
	"stroke-linejoin": "round",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", { d: "M3.5 22.2c.3-4.5 4-8 8.5-8s8.2 3.5 8.5 8z" }, null, -1), createElementVNode("circle", {
		cx: "12",
		cy: "6.2",
		r: "4.5"
	}, null, -1)])]);
}
var User_default = { render: render$1 };
//#endregion
export { User_exports, User_default as default, render$1 as render };

//# sourceMappingURL=User.svg.virtual.js.map